__turbopack_context__.v({
  "checkbox": "CMvglG_checkbox",
  "checkboxChecked": "CMvglG_checkboxChecked",
  "clearButton": "CMvglG_clearButton",
  "dropdown": "CMvglG_dropdown",
  "dropdownLg": "CMvglG_dropdownLg",
  "error": "CMvglG_error",
  "hiddenWrapper": "CMvglG_hiddenWrapper",
  "input": "CMvglG_input",
  "inputField": "CMvglG_inputField",
  "label": "CMvglG_label",
  "option": "CMvglG_option",
  "optionContent": "CMvglG_optionContent",
  "options": "CMvglG_options",
  "overflowBadge": "CMvglG_overflowBadge",
  "pill": "CMvglG_pill",
  "pillsList": "CMvglG_pillsList",
  "required": "CMvglG_required",
  "rightControls": "CMvglG_rightControls",
  "root": "CMvglG_root",
  "section": "CMvglG_section",
  "wrapper": "CMvglG_wrapper",
});
